<template>

  <div class="login-container" id="loginz" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div class="login-content">
      <div class="login-title">
        <h3>{{InsName}}用户中心</h3>
      </div>
      <div class="login-main flex">
        <div class="login-right">
          <p class="logintop">用户登录</p>
          <form action="">
            <p><input type="text" class="input_border" placeholder="用户名" v-model="name"></p>
            <p><input type="password" class="input_border" placeholder="登录密码" v-model="pwd" @keyup.enter="enterlogin()"></p>
            <p>
              <el-button type="primary" round @click="login()" style="margin-top:2%">登录</el-button>
            </p>
            <hr style="margin: 4% 0">
            <div class="modify_pwd">
              <a href="javascript:;" class="m" @click="register()"> 账户注册</a>
              <span style="margin:0 20px">|</span>
              <a href="javascript:;" class="m" @click="forgetPassword()">忘记密码 ？</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "login",
  data() {
    return {
      loading: "",
      checked: false,
      isShow: true,
      name: "",
      pwd: "",
      InsName: "",
      inscode: "",
      insTestProp: "",
    };
  },
  created() {
    this.InsName = JSON.parse(sessionStorage.getItem("InsNameCn"));
    document.getElementsByTagName("title")[0].innerText = '用户中心'; 
    this.clearCache();
    this.getInsTestPropFn();
    this.checkLogin();
    this.getusername();
    
  },
  watch: {
    "$route": "getInsTestPropFn"
  },
  methods: {
    getInsTestPropFn() {  // 获取机构性质
      var insCode = window.location.hash.slice(8, 100).split("?")[0];
      var postData = "insCode=" + insCode;
      var url = "/register/GetInsTestProp";
      this.$api.post(url, postData, response => {
        if (response.Ret == 0) {
          this.insTestProp = response.Data;
          sessionStorage.setItem("insTestProp", JSON.stringify(this.insTestProp));
        } else {
          this.$alert(response.Msg);
        }
      });
    },
    checkLogin() {
      //获取链接参数
      let redirectUrlType = this.$route.query.redirectType;
      if (redirectUrlType == "" || redirectUrlType == null) {
        return;
      }

      let objUserInfo = JSON.parse(localStorage.getItem("autoLoginInfo"));
      localStorage.removeItem("autoLoginInfo");
      sessionStorage.setItem("uname", objUserInfo.UserCode);
      sessionStorage.setItem("uname111", "测试==" + objUserInfo.UserCode);
      this.$store.state.inscode = objUserInfo.InsCode;
      this.$store.state.uname = objUserInfo.UserCode;
      this.$store.state.islogin = true;

      var mtoken = {
        token: objUserInfo.Token,
        expire: objUserInfo.ExpireDate,
        refreshtoken: objUserInfo.RefreshToken,
        secretkey: objUserInfo.SecretKey
      };

      sessionStorage.setItem(
        "token" + objUserInfo.UserCode,
        JSON.stringify(mtoken)
      );

      sessionStorage.setItem("userInfo", JSON.stringify(objUserInfo));
      sessionStorage.setItem("inscode", objUserInfo.InsCode);
      console.log(sessionStorage.getItem("uname"));
      if (redirectUrlType == 0) {
        this.$router.push({ path: "/Recharge" });
      } else if (redirectUrlType == 1) {
        this.$router.push({ path: "/withdrawdeposit" });
      } else {
        this.$router.push({ path: "/index" });
      }
    },
    getusername() {
      var cat = localStorage.getItem("username");
      if (typeof cat == undefined) {
        return;
      } else {
        this.name = cat;
        this.checked = true;
      }
    },
    rememberusername() {
      if (this.checked == false) {
        localStorage.setItem("username", "");
        return;
      } else {
        var username = this.name;
        localStorage.setItem("username", username);
        var cat = localStorage.getItem("username");
      }
    },
    enterlogin() {
      if (this.pwd == "") {
        return;
      } else {
        this.login();
      }
    },
    clearCache() {
      var uname = sessionStorage.getItem("uname");
      var token = "token" + uname;
      sessionStorage.removeItem("uname");
      sessionStorage.removeItem("inscode");
      sessionStorage.removeItem("InsName");
      sessionStorage.removeItem("pwd");
      sessionStorage.removeItem(token);
      sessionStorage.removeItem("pubkey");
      this.$store.state.inscode = "";
      this.$store.state.uname = "";
      this.$store.state.pwd = "";
      this.$store.state.islogin = false;
      this.$store.state.userInfo = {};
      this.$store.state.accountChecked = false;
    },
    login() {
      let timeStap = Math.round(new Date().getTime() * 0.001);
      this.inscode = window.location.hash.split("?")[0].slice(8, 100);
      if (this.inscode == "") {
        this.$alert("请请在地址栏输入正确链接地址，按回车键进入系统！");
        return;
      }
      sessionStorage.setItem("valueHash", window.location.hash.split("?")[0].slice(1, 20));
      localStorage.setItem("url", window.location.href);

      if (this.name == null || this.name == "") {
        this.$alert("请输入正确的账号", {
          confirmButtonText: "确定",
          center: "true",
          callback: action => {
            this.name = "";
          }
        });
        return;
      }
      if (this.pwd == null || this.pwd == "") {
        this.$alert("请输入正确的密码", {
          confirmButtonText: "确定",
          center: "true",
          callback: action => {
            this.pwd = "";
          }
        });
        return;
      }
      sessionStorage.setItem("uname", this.name);
      this.$store.state.inscode = this.inscode;
      this.$store.state.uname = this.name;
      this.$store.state.pwd = this.pwd + "&" + timeStap;
      this.loading = true;
      this.$loginapi.login(
        this.inscode,
        this.name,
        this.pwd + "&" + timeStap,
        e => {
          this.loading = false;
          this.$store.state.pwd = "";
          if (e.Ret == 0) {
            this.$router.push({ path: "/index" });
            return;
          } else {
            this.$alert(e.Msg, {
              confirmButtonText: "确定",
              center: "true",
              callback: action => {
                this.pwd = "";
              }
            });
          }
        }
      );
      this.rememberusername();
    },
    // 用户注册
    register() {
      this.inscode = window.location.hash.split("?")[0].slice(8, 100);
      if (this.inscode == "") {
        this.$alert("请请在地址栏输入正确链接地址，在点击进入注册页面！");
        return;
      }
      this.$router.push("/register/" + this.inscode);
      // let postData = "insCode=" +  this.inscode
      // let url = "/register/GetInsTestProp";
      // this.$api.post(url,postData, response => {
      //   if (response.Ret == 0) {
      //   let num = response.Data;
      //   this.$router.push("/register/" + this.inscode + "/" + num );
      //   } else {
      //     this.$message.error(response.Msg);
      //   }
      // });
    },
    forgetPassword(){

        this.inscode = window.location.hash.split("?")[0].slice(8, 100);

        console.log(window.location.hash.split("?")[0])
        if (this.inscode == "") {

          this.$alert("请请在地址栏输入正确链接地址，在点击进入注册页面！");
          return;
        }
        sessionStorage.setItem("pswdpageiscode", window.location.hash.split("?")[0].slice(1, 20));
        this.$router.push("/forgetPswd");
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue